// This file was automatically generated from appshared.docTags.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.docTags');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.feedItemId && opt_data.docTags.length > 0) ? '<img class="doc-tag-icon el8FeedItemDocTagIcon" src="/static/images/tag_small.png"/>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.tooltipCombined = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="add-edit-tags-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  var docTagList9081 = opt_data.docTagMaps;
  var docTagListLen9081 = docTagList9081.length;
  for (var docTagIndex9081 = 0; docTagIndex9081 < docTagListLen9081; docTagIndex9081++) {
    var docTagData9081 = docTagList9081[docTagIndex9081];
    output.append('<div class="el8DocTagTooltipWrap"><div class="el8DocTagTooltipValue">', soy.$$escapeHtml(docTagData9081.value), '</div>', (docTagData9081.code) ? '<div class="el8DocTagTooltipCodeLine">' + soy.$$escapeHtml(docTagData9081.code) + ' (' + soy.$$escapeHtml(docTagData9081.codeType) + ')</div>' : '', (docTagData9081.description) ? '<div class="el8DocTagTooltipDescriptionNew">' + soy.$$escapeHtml(docTagData9081.description) + '</div>' : '', '</div>');
  }
  output.append('</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DocTagsLineWrap ', (opt_data.align && opt_data.align == 'right') ? 'el8AlignRight' : '', '">');
  var tagList9106 = opt_data.docTags;
  var tagListLen9106 = tagList9106.length;
  for (var tagIndex9106 = 0; tagIndex9106 < tagListLen9106; tagIndex9106++) {
    var tagData9106 = tagList9106[tagIndex9106];
    output.append('<div class="el8DocTagWrap">');
    el8.template.appshared.docTags.docTag({tag: tagData9106}, output);
    output.append('</div>');
  }
  output.append((opt_data.feedItemId && opt_data.docTags.length > 0) ? '<a class="add-edit-tags-trigger el8FontSmall" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">edit</a>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTagsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<fieldset class="noBorderForm"><div class="doctags"></div></fieldset>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTagsLine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label></label><div class="el8FieldShortLabelPadding">');
  if (opt_data.docTags) {
    var tagList9124 = opt_data.docTags;
    var tagListLen9124 = tagList9124.length;
    for (var tagIndex9124 = 0; tagIndex9124 < tagListLen9124; tagIndex9124++) {
      var tagData9124 = tagList9124[tagIndex9124];
      output.append('<div class="el8DocTagWrap">');
      el8.template.appshared.docTags.docTag({tag: tagData9124}, output);
      output.append('</div>');
    }
  }
  output.append((opt_data.docTags && opt_data.docTags.length > 0) ? '<a class="add-edit-tags-trigger el8FormLink">edit</a>' : '<a class="add-edit-tags-trigger el8FormLink">+ Tag</a>', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="', (opt_data.tag.code) ? 'el8DocTagCoded doctag-coded' : 'el8DocTag', ' ', (opt_data.removeButton) ? 'mr8' : '', '" data-id="', soy.$$escapeHtml(opt_data.tag.id), '">', (opt_data.tag.code) ? '' : '', soy.$$escapeHtml(opt_data.tag.value), (opt_data.tag.code) ? '&thinsp;&bull;' : '', '</span>', (opt_data.removeButton) ? '<a class="el8RemoveButton el8StandardFontSize remove-trigger"></a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.tooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DocTagTooltipWrap"><div class="el8DocTagTooltipValue">', soy.$$escapeHtml(opt_data.docTag.value), '</div>', (opt_data.docTag.code) ? '<div class="el8DocTagTooltipCodeLine">' + soy.$$escapeHtml(opt_data.docTag.code) + ' (' + soy.$$escapeHtml(opt_data.docTag.codeType) + ')</div>' : '', (opt_data.docTag.description) ? '<div class="el8DocTagTooltipDescription">' + soy.$$escapeHtml(opt_data.docTag.description) + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
